import { createContext, useContext, useEffect } from 'react';

type ReleaseSidebarCollapse = () => void;
type RequestSidebarCollapse = () => ReleaseSidebarCollapse;

function keepSidebarAsIs(): ReleaseSidebarCollapse {
  return () => undefined;
}

export const SidebarCollapseRequestContext = createContext<RequestSidebarCollapse>(keepSidebarAsIs);

export function useTemporarySidebarCollapse(selectedId: number | null) {
  const requestSidebarCollapse = useContext(SidebarCollapseRequestContext);

  useEffect(() => {
    if (selectedId === null) return;
    return requestSidebarCollapse();
  }, [selectedId, requestSidebarCollapse]);
}
